import { render } from "./avaliable.vue?vue&type=template&id=40d64ed0"
import script from "./avaliable.vue?vue&type=script&lang=js"
export * from "./avaliable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__